import React from "react";
import styled from "styled-components";
import CustomNetworkImage from "../image/CustomNetworkImage";
import { Column, Row } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { Theme } from "../../Theme";

const PopupOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${Theme.color.black_05};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const PopupContainer = styled.div`
    background-color: transparent;
    width: 70%;
    height: 75%;
`;

/**
 * 팝업 컴포넌트
 * @param {boolean} isOpen - 팝업 표시 여부
 * @param {function} onClose - 닫기(취소) 버튼 클릭 시 호출될 함수
 * @param {string} src - 이미지 url
 * @param {string} altText - 이미지 로드 불가시 노출 텍스트
 */
const SingleImagePopup = ({ isOpen, onClose, src, altText }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <PopupOverlay>
            <Column width={"100%"} height={"100%"} justifyContent={"flex-start"} alignItems={"center"}>
                <Row width={"100%"} justifyContent={"flex-end"} padding={"40px 40px 40px 0"}>
                    <CustomIcon iconName={"image_close_button"} size={"40px"} onClick={onClose} cursor={"pointer"} />
                </Row>
                <PopupContainer onClick={(e) => e.stopPropagation()}>
                    <CustomNetworkImage src={src} alt={altText} size={"100%"} borderRadius={"12px"} />
                </PopupContainer>
            </Column>
        </PopupOverlay>
    );
};

export default SingleImagePopup;
